import { ChangeEvent } from 'react'
import { useTranslation } from 'next-i18next'

import useSettingsFormContext from '~/hooks/useSettingsFormContext'
import { City } from '~/types/booking'
import { FieldError } from '~/components/FieldError'
import { SelectBoxHomGradient } from '~/components/SelectBoxHomGradient'
import { UserRole } from '~/types/user-info-types'

export default function LocationSetting({ role }: { role: string }): React.ReactElement {
  const namespace = role === UserRole.TUTOR ? 'tutorPanel' : 'studentPanel'
  const { t } = useTranslation(['booking', namespace])
  const { fields, setFields, errors } = useSettingsFormContext()

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    setFields((prevState) => ({
      ...prevState,
      city: event.target.value as City,
    }))
  }

  return (
    <div className="flex flex-col">
      <SelectBoxHomGradient name="city" onChange={handleOnChange} value={fields.city}>
        <option value="">{t(`${namespace}:settings.labelSelectCity` as const)}</option>
        {Object.values(City).map((elem) => (
          <option key={elem} value={elem}>
            {t(`booking:cities.${elem}` as const)}
          </option>
        ))}
      </SelectBoxHomGradient>
      <FieldError error={errors.city} />
    </div>
  )
}
